import React from "react";
import Table from "../Table";
import ResponseViewer from "../ResponseViewer";
import CodeBlock from "../CodeBlock";
import * as Constants from "../../constants/Constants";
const MainSection = ({id, menuIndex, navIndex, subMenuIndex, index, currMethod, headers, parameters, responsesTable, methodType, requestResponse, methodPath, requestBody, methodSummary, operationSummary, path, requestParameters}) => {
  return (
    <>
      <div className="main-section api-detail" data-open-index={navIndex} data-index={index} data-menu-index={menuIndex} data-subMenu-index={subMenuIndex} id= {`${id}`} data-id={`${methodSummary}`} >
        <h2 id="span-classsidebar-link-textget-applicants-for-a-jobspan-span-class-api-method-getgetspan">
          <span className="sidebar-link-text method-name" id= {`${methodSummary}`} >{methodSummary}</span>
          <span className={`api-method ${methodType}`}>{methodType}</span>
        </h2>
        <CodeBlock headers={headers} path={path} methodType={methodType} currMethod={currMethod}/>
        <p>
          <code>
            {methodPath}
          </code>
        </p>
        <p>
          <em>{operationSummary}</em>
        </p>
        { headers && <>
          <h3 id="get-applicants-for-a-job-parameters">Headers</h3>
          <Table data={headers} />
        </>
        }
        {requestBody &&
        <div className="method-example-part example-request-body">
          <blockquote>
            <p>Body Parameter</p>
          </blockquote>
          <ResponseViewer data={requestBody} type={Constants.Values.TABLE_NAME_BODY_PARAMETER} />
        </div>
        }
        {parameters.length>=1 &&
        <>
          <h3 id="get-applicants-for-a-job-parameters">Parameters</h3>
          <Table data={parameters} />
        </>
        }
        {requestParameters &&
        <>
          <h3 id="get-applicants-for-a-job-parameters">Request Parameters</h3>
          <Table data={requestParameters} tableName={Constants.Values.TABLE_NAME_REQUEST_PARAMETERS}/>
        </>}
        <div style={{maxHeight: "268px"}}>
          <div className="method-example-part response-header">
            <p>Response</p>
          </div>
          <div className="method-example-part example-request-response">
            {requestResponse &&
              requestResponse.map((item) => {
                const {Description, Schema} = item;
                return (
                  <>
                    <blockquote>
                      <p>{Description}</p>
                    </blockquote>
                    <ResponseViewer data={Schema} type={Constants.Values.TABLE_NAME_RESPONSES} />
                  </>
                );
              })}
          </div>
        </div>

        { responsesTable &&
      <>
        <h3 id="get-applicants-for-a-job-responses">Responses</h3>
        <Table data={responsesTable} tableName={Constants.Values.TABLE_NAME_RESPONSES} />
      </>
        }
      </div>

    </>

  );
};

export default MainSection;
